import { FunctionComponent } from "react";

export const MessageCell: FunctionComponent = ({ children }) => (
    <td style={{ lineHeight: 1.2 }}>
        {children}
    </td>
);
